import { api } from '@/plugins'
import {
  GET_CLIENTS,
  GET_CLIENTS_SUCCESS,
  GET_CLIENTS_FAIL
} from './mutations'

export default {
  list ({ commit }) {
    return new Promise((resolve, reject) => {
      commit(GET_CLIENTS)

      api
        .GET('client/list')
        .then(async datas => {
          await commit(GET_CLIENTS_SUCCESS, datas)
          resolve(datas)
        })
        .catch(e => {
          commit(GET_CLIENTS_FAIL)
          reject(e)
        })
    })
  }
}
